export default {
    showing: 'showing',
    to: 'to',
    of: 'of',
    result: 'result',
};
